import React, { useEffect } from 'react';

import UpdateProgress from './UpdateProgress';
import LogReader from './LogReader';

import './UpdatePage.css';

export default function UpdatePage(props) {
  const { ghToken } = props || {};
  const checkForUpdates = () => {
    if (window.ipc && typeof window.ipc.send === 'function') {
      window.ipc.send('checkForUpdates', ghToken);
    }
  };
  useEffect(() => {
    checkForUpdates();
  }, []);

  return (
    <div className="update-page">
      <h2>Update Hippo</h2>
      <UpdateProgress checkForUpdates={checkForUpdates} />
      <LogReader />
    </div>
  );
}
